let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4tzMC")).then(() => parcelRequire('354y1'));